import store from '@/store'
export default {
  // 开始 loading
  loading (options = {}) {
    store.dispatch('common/handleLoading', true)
  },
  // 结束 loading
  cancel () {
    store.dispatch('common/handleLoading', false)
  },
  // 強制取消 loading
  hideLoading() {
    store.commit('common/hideLoading')
  }
}
